import React, { useState, useEffect } from 'react'
import { Header } from '../Header/Header'
import MobileSidebar from '../MobileSidebar/MobileSidebar'
import Sidebar from '../Sidebar/Sidebar';

const Layout = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
        setLoading(false);
        }, 2000);
    }, []);

    useEffect(() => {

        const updateIsMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        updateIsMobile();

        window.addEventListener('resize', updateIsMobile);

        return () => {
            window.removeEventListener('resize', updateIsMobile);
        };
    }, []);

    const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (event) => {
        setCursorPosition({ x: event.clientX, y: event.clientY });
    };

    
  return (
    <div onMouseMove={handleMouseMove}>
        {loading ? (
            <div className="ring">Loading
                <span></span>
            </div>
        ) : (
            <>
                <div className="custom-cursor" style={{ left: cursorPosition.x, top: cursorPosition.y }}></div>
                <Header />
                {isMobile ? (<MobileSidebar />) : (<Sidebar />)}
                {children}
            </>
        )}
    </div>
  )
}

export default Layout